import { makeRequest } from 'utils/requestLogger';

export default (keywords, roundtable_id) =>
  makeRequest('post', `/api/roundtables/${roundtable_id}/updateKeywords`, {
    keywords,
  });



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/updateKeywords.js